<h4 class="sidebar-title">Have a question?</h4>
<p class="sidebar-description">Our team is here to help however we can</p>

@for (member of staff(); track member.id) {
  <div class="staff-card">
    <p class="staff-name">{{ member.name }}</p>
    <p class="staff-email">{{ member.email }}</p>
  </div>
} @empty {
  <div class="staff-card">
    <p class="staff-name staff-name-muted">No staff assigned</p>
  </div>
}
